import React from "react";
import "../../pages/style.css";

function Text() {
  return (
    <p className="role-line">
      React developer / UI builder / problem solver
    </p>
  );
}

export default Text;
